import React from 'react';
import { useAvatarUpload } from '../../hooks/useAvatarUpload';
import './AvatarUploadModal.css';

const AvatarUploadModal = ({ onClose, onSuccess }) => {
  const {
    selectedFile,
    previewUrl,
    uploadLoading,
    uploadError,
    handleFileSelect,
    uploadAvatar
  } = useAvatarUpload((updatedUser) => {
    onSuccess(updatedUser);
    onClose();
  });

  return (
    <>
      <div className="modal-overlay" onClick={onClose} />
      <div className="avatar-upload-modal">
        <h3>Upload Custom Avatar</h3>

        <input
          type="file"
          accept="image/jpeg,image/png,image/webp"
          onChange={handleFileSelect}
          className="file-input"
        />

        {previewUrl && (
          <div className="preview-container">
            <p>Preview:</p>
            <img
              src={previewUrl}
              alt="Avatar preview"
              className="avatar-preview"
            />
          </div>
        )}

        {uploadError && (
          <div className="error-message">{uploadError}</div>
        )}

        <div className="modal-actions">
          <button
            onClick={uploadAvatar}
            disabled={!selectedFile || uploadLoading}
            className="btn btn-primary"
          >
            {uploadLoading ? 'Uploading...' : 'Upload Avatar'}
          </button>
          <button
            onClick={onClose}
            disabled={uploadLoading}
            className="btn btn-secondary"
          >
            Cancel
          </button>
        </div>

        <p className="upload-info">
          Accepted formats: JPEG, PNG, WebP (Max 5MB)
        </p>
      </div>
    </>
  );
};

export default AvatarUploadModal;